// @flow

import React, { useRef } from 'react';
import {
    Container,
    Typography,
    TextField,
    Button,
    FormGroup,
    FormControl,
} from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { DropzoneArea } from 'material-ui-dropzone';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/icons/Delete';
import Env from '../../../config/environment';
import './style.css';

function Contact() {
    const [filesDropOpen, setFilesDropOpen] = React.useState(false);
    const [values, setValues] = React.useState({});
    const [errors, setErrors] = React.useState({});
    const [acctedFiles, setfilenames] = React.useState([]);
    const [open, setOpen] = React.useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const inputRef = useRef();
    const handleChange = (event) => {
        event.persist();
        setValues((values) => ({
            ...values,
            [event.target.name]: event.target.value,
        }));
    };
    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }
    const AWS = require('aws-sdk');
    const s3 = new AWS.S3({
        accessKeyId: Env.AccessKeyId,
        secretAccessKey: Env.SecretAccessKey,
        region: Env.Region,
    });
    const initialState = {
        email: '',
        subject: '',
        description: '',
        firstname: '',
        lastname: '',
    };
    const clearState = () => {
        setValues({ ...initialState });
    };
    const handleRemoveItem = () => {
        var index = acctedFiles.length - 1;
        setfilenames(acctedFiles.splice(index + 1, index));
    };
    const handleSubmit = (event) => {
        if (event) event.preventDefault();
        setErrors(validate(values));

        if (
            values.email &&
            values.subject &&
            values.description &&
            values.firstname &&
            values.lastname
        ) {
            let filename = [];
            acctedFiles.map((acctedFile) => {
                return filename.push(acctedFile.file.name);
            });

            let student = {
                email: values.email,
                subject: values.subject,
                description: values.description,
                firstname: values.firstname,
                lastname: values.lastname,
                filename: filename,
            };
            var today = new Date(),
                date =
                    today.getFullYear() +
                    '-' +
                    (today.getMonth() + 1) +
                    '-' +
                    today.getDate() +
                    '-' +
                    today.getHours() +
                    ':' +
                    today.getMinutes() +
                    ':' +
                    today.getSeconds();

            const params = {
                Bucket: Env.BucketName, // pass your bucket name
                Key: values.firstname + '-' + date + '.json', // file will be saved as testBucket/contacts.csv
                Body: JSON.stringify(student, null, 2),
            };
            s3.upload(params, function (s3Err) {
                if (s3Err) throw s3Err;
            });

            acctedFiles.map((acctedFile) => {
                const params = {
                    Bucket: Env.BucketName, // pass your bucket name
                    Key: acctedFile.file.name, // file will be saved as testBucket/contacts.csv
                    Body: acctedFile.file,
                };
                // s3.upload(params, function (s3Err,data)
                //{
                // if (s3Err) throw s3Err;
                //console.log(data);
                //});
                // });
                s3.upload(params, function (s3Err) {
                    if (s3Err) throw s3Err;
                });
                return'success';
            });
            setOpen(true);
            clearState();
            handleRemoveItem();
        }
    };

    const validate = (values) => {
        let errors = {};
        if (!values.email) {
            errors.email = 'Email Address is Required';
        } else {
            if (
                !RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
                    values.email
                )
            ) {
                errors.email = 'Email Address is Required';
            }
        }
        if (!values.subject) {
            errors.subject = 'Subject is Required';
        }
        if (!values.description) {
            errors.description = 'Description is Required';
        }
        if (!values.firstname) {
            errors.firstname = 'FirstName is Required';
        }
        if (!values.lastname) {
            errors.lastname = 'LastName is Required';
        }
        return errors;
    };

    const onDrop = (files) => {
        setfilenames([
            ...acctedFiles,
            {
                file: files,
            },
        ]);
        console.log(acctedFiles);
    };
    // const handleFilesDropOpen = () => {
    //     setFilesDropOpen(true);
    // };
    const handleFilesDropSave = () => {
        setFilesDropOpen(false);
    };
    const handleFilesDropClose = () => {
        setFilesDropOpen(false);
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = acctedFiles.filter(
            (item, itemIndex) => index !== itemIndex
        );
        setfilenames([...updatedFiles]);
        console.log(acctedFiles);
    };
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [inputRef]);
    return (
        <Container maxWidth="md" className="contact-form">
            <h1 className="page-title">Submit a Request</h1>
            <FormGroup aria-label="position" row>
                <FormControl>
                    <TextField
                        id="contact-email"
                        name="email"
                        label="Email Address"
                        placeholder="john.smith@email.com"
                        helperText=""
                        required
                        error={errors.email ? true : false}
                        onChange={handleChange}
                        value={values.email || ''}
                        
                    />
                </FormControl>
                <FormControl>
                    <TextField
                        id="contact-subject"
                        label="Subject"
                        name="subject"
                        placeholder="Subject*"
                        helperText=""
                        error={errors.subject ? true : false}
                        onChange={handleChange}
                        value={values.subject || ''}
                        required
                    />
                </FormControl>
                <FormControl>
                    <TextField
                        id="contact-description"
                        label="Description"
                        name="description"
                        placeholder="Enter Description Here*"
                        helperText=""
                        fullWidth
                        multiline
                        rows="7"
                        error={errors.description ? true : false}
                        onChange={handleChange}
                        value={values.description || ''}
                        required
                        variant="outlined"
                        
                    />
                </FormControl>
                <FormControl>
                    <TextField
                        id="contact-firstname"
                        label="First Name"
                        placeholder="First Name*"
                        helperText=""
                        name="firstname"
                        ref={inputRef}
                        error={errors.firstname ? true : false}
                        onChange={handleChange}
                        value={values.firstname || ''}
                        required
                         
                    />
                </FormControl>
                <FormControl>
                    <TextField
                        id="contact-lastname"
                        label="Last Name"
                        placeholder="Last Name*"
                        helperText=""
                        name="lastname"
                        ref={inputRef}
                        error={errors.lastname ? true : false}
                        onChange={handleChange}
                        value={values.lastname || ''}
                         
                    />
                </FormControl>
                <FormControl>
                    <DropzoneArea
                        open={filesDropOpen}
                        acceptedFiles={['image/*', 'application/*', '.zip']}
                        onSave={handleFilesDropSave}
                        onClose={handleFilesDropClose}
                        maxFileSize={100000}
                        showAlerts={false}
                        showPreviewsInDropzone={false}
                        showPreviews={false}
                        showFileNames={false}
                        dialogTitle="Upload Files"
                        submitButtonText="Save"
                        cancelButtonText="Close"
                        dropzoneText="Click here to add a file or drop files here.(Maximum file size should be less than 100kb.)"
                        dropzoneClass="files-dropzone"
                        dropzoneParagraphClass="dropzone-note"
                        onDrop={onDrop}
                    />

                    {acctedFiles.length === 0 ? (
                        ''
                    ) : (
                        <Typography
                            component="div"
                            className="btn-acceptedfile"
                        >
                            <Typography component="ul">
                                Uploaded Files
                                {acctedFiles.length > 0 &&
                                    acctedFiles.map((row, index) => (
                                        <Typography key={index} component="li">
                                            {row.file.name}
                                            <Typography
                                                component="span"
                                                className="icon-btn"
                                            >
                                                <IconButton
                                                    onClick={() =>
                                                        handleRemoveFile(index)
                                                    }
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Typography>
                                        </Typography>
                                    ))}
                            </Typography>
                        </Typography>
                    )}
                </FormControl>
                <FormControl>
                    <Button
                        type="submit"
                        onClick={handleSubmit}
                        variant="contained"
                    >
                        SUBMIT
                    </Button>
                </FormControl>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert onClose={handleClose} severity="success">
                        Request Saved Successfully.
                    </Alert>
                </Snackbar>
            </FormGroup>
        </Container>
    );
}

export default Contact;
